import { createTheme } from '@mui/material';

export const DarkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#ab003f',
            dark: '#89003a',
            light: '#d31343',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#9b2658',
            dark: '#771f4d',
            light: '#e891b2',
            contrastText: '#ffffff',
        },
        background: {
            default: '#202124',
            paper: '#303134',
        }
    },
    typography: {
        allVariants: {
            color: 'white'
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
                ::-webkit-scrollbar {
                    width: 5px;
                    height: 5px;
                }
                ::-webkit-scrollbar-track {
                    background: #303134;
                }
                ::-webkit-scrollbar-thumb {
                    background-color: #888;
                    border-radius: 10px;
                    border: 2px solid #303134;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background-color: #555;
                }
                html {
                    scrollbar-width: thin;
                    scrollbar-color: #888 #303134;
                }
            `,
        },
    },
});
